var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c("div", { staticClass: "single container-max page-content" }, [
            _c("div", { staticClass: "row position-relative" }, [
              _c(
                "div",
                { staticClass: "col-12 col-lg-6 mt-5" },
                [_vm._t("image-carousel")],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-6 mt-md-5" }, [
                _c(
                  "div",
                  [
                    _c(
                      "h1",
                      {
                        staticClass: "h2 title",
                        attrs: { "data-testing": "item-name" }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("itemName")(_vm.currentVariation)) +
                              "\n              "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "d-inline-block ml-n3 mb-3",
                        attrs: { href: "#feedback-container" }
                      },
                      [
                        _c("feedback-average", {
                          attrs: {
                            "show-empty-ratings": false,
                            "size-of-stars": "3",
                            "show-ratings-amount": true
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-wrap justify-content-between mb-4"
                      },
                      [
                        _vm.currentVariation.texts.technicalData !== ""
                          ? _c("div", { staticClass: "advantages" }, [
                              _c("div", [
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Ihre Vorteile:")]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.technicalData
                                    )
                                  }
                                })
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "emicode-siegel d-flex align-items-center"
                          },
                          [
                            _vm._l(
                              _vm.currentVariation.variationProperties,
                              function(variationPropertyGroup) {
                                return [
                                  _vm._l(
                                    variationPropertyGroup.properties,
                                    function(variationProperty) {
                                      return [
                                        variationProperty.id == 17
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  key:
                                                    "emicode-" +
                                                    variationProperty.id,
                                                  attrs: {
                                                    href: "/emicode",
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    key: variationProperty.id,
                                                    staticClass:
                                                      "img-fluid mt-4 mt-md-0",
                                                    attrs: {
                                                      src:
                                                        variationProperty.values
                                                          .value,
                                                      alt: "Emicode Siegel"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ]
                                    }
                                  )
                                ]
                              }
                            )
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.currentVariation.variationProperties, function(
                      variationPropertyGroup
                    ) {
                      return [
                        _vm._l(variationPropertyGroup.properties, function(
                          variationProperty
                        ) {
                          return [
                            variationProperty.id == 13
                              ? _c(
                                  "div",
                                  {
                                    key:
                                      "app-" +
                                      variationPropertyGroup.id +
                                      "-" +
                                      variationProperty.id,
                                    staticClass: "application mb-4"
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [_vm._v("Einsatzgebiete:")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.currentVariation
                                            .variationProperties,
                                          function(variationPropertyGroup2) {
                                            return [
                                              _vm._l(
                                                variationPropertyGroup2.properties,
                                                function(variationProperty2) {
                                                  return [
                                                    variationProperty2.id == 13
                                                      ? [
                                                          _c(
                                                            "ul",
                                                            {
                                                              key:
                                                                "list-" +
                                                                variationPropertyGroup2.id +
                                                                "-" +
                                                                variationProperty2.id,
                                                              staticClass:
                                                                "d-flex"
                                                            },
                                                            _vm._l(
                                                              variationProperty2.values,
                                                              function(
                                                                selects,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "li",
                                                                  {
                                                                    key:
                                                                      "select-" +
                                                                      index
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        selects.value
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ]
                                                }
                                              )
                                            ]
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        })
                      ]
                    }),
                    _vm._v(" "),
                    _vm._l(
                      _vm.currentVariation.properties.filter(function(prop) {
                        return prop.propertyId === 60
                      }),
                      function(item) {
                        return _c(
                          "div",
                          {
                            key: "danger-" + item.propertyId + "-" + item.id,
                            staticClass: "danger-wrapper p-4 bg-gray mb-4"
                          },
                          [
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("Sicherheitshinweise für Gefahrenstoffe:")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between mt-2 flex-wrap"
                              },
                              [
                                _vm._l(
                                  _vm.currentVariation.properties.filter(
                                    function(prop) {
                                      return prop.propertyId === 60
                                    }
                                  ),
                                  function(item2) {
                                    return _c(
                                      "p",
                                      {
                                        key: "add-data-" + item2.id,
                                        staticClass: "add-data"
                                      },
                                      [_vm._v(_vm._s(item2.texts.value))]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "picto d-flex justify-content-between"
                                  },
                                  [
                                    _vm._l(
                                      _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.propertyId === 48
                                        }
                                      ),
                                      function(item3) {
                                        return _c(
                                          "div",
                                          { key: "picto-48-" + item3.id },
                                          _vm._l(
                                            item3.texts.value.split(","),
                                            function(url, index) {
                                              return _c("img", {
                                                key:
                                                  "img-48-" +
                                                  item3.id +
                                                  "-" +
                                                  index,
                                                staticClass:
                                                  "danger-img mr-2 img-fluid d-inline-block",
                                                attrs: { src: url }
                                              })
                                            }
                                          ),
                                          0
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.propertyId === 49
                                        }
                                      ),
                                      function(item4) {
                                        return _c(
                                          "div",
                                          { key: "picto-49-" + item4.id },
                                          _vm._l(
                                            item4.texts.value.split(","),
                                            function(url, index) {
                                              return _c("img", {
                                                key:
                                                  "img-49-" +
                                                  item4.id +
                                                  "-" +
                                                  index,
                                                staticClass:
                                                  "danger-img mr-2 img-fluid d-inline-block",
                                                attrs: { src: url }
                                              })
                                            }
                                          ),
                                          0
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.propertyId === 50
                                        }
                                      ),
                                      function(item5) {
                                        return _c(
                                          "div",
                                          { key: "picto-50-" + item5.id },
                                          _vm._l(
                                            item5.texts.value.split(","),
                                            function(url, index) {
                                              return _c("img", {
                                                key:
                                                  "img-50-" +
                                                  item5.id +
                                                  "-" +
                                                  index,
                                                staticClass:
                                                  "danger-img mr-2 img-fluid d-inline-block",
                                                attrs: { src: url }
                                              })
                                            }
                                          ),
                                          0
                                        )
                                      }
                                    )
                                  ],
                                  2
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "danger-container" }, [
                              _c(
                                "div",
                                { staticClass: "mt-5" },
                                [
                                  _vm._l(
                                    _vm.currentVariation.properties.filter(
                                      function(p) {
                                        return p.propertyId === 54
                                      }
                                    ),
                                    function(prop) {
                                      return _c(
                                        "div",
                                        { key: "comp-a-" + prop.id },
                                        [
                                          _c("h4", [
                                            _vm._v("Hinweise Komponente A")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "danger-hints mt-4"
                                            },
                                            [
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 48
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "danger-pikto-48-" +
                                                        item.id,
                                                      staticClass:
                                                        "row mb-3 danger-pikto"
                                                    },
                                                    [
                                                      _vm._m(0, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto text-center"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                48
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-48-" +
                                                                  item2.id
                                                              },
                                                              _vm._l(
                                                                item2.texts.value.split(
                                                                  ","
                                                                ),
                                                                function(
                                                                  url,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "img",
                                                                    {
                                                                      key:
                                                                        "img-48-" +
                                                                        item2.id +
                                                                        "-" +
                                                                        index,
                                                                      staticClass:
                                                                        "danger-img mr-2 img-fluid d-inline-block",
                                                                      attrs: {
                                                                        src: url
                                                                      }
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 51
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "signal-51-" + item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(1, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                51
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-51-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 54
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "danger-54-" + item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(2, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                54
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-54-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 57
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "safety-57-" + item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(3, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                57
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-57-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 60
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "additional-60-" +
                                                        item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(4, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                60
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-60-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.currentVariation.properties.filter(
                                      function(p) {
                                        return p.propertyId === 55
                                      }
                                    ),
                                    function(prop) {
                                      return _c(
                                        "div",
                                        {
                                          key: "comp-b-" + prop.id,
                                          staticClass: "mt-5"
                                        },
                                        [
                                          _c("h4", [
                                            _vm._v("Hinweise Komponente B")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "danger-hints mt-4"
                                            },
                                            [
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 49
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "danger-pikto-49-" +
                                                        item.id,
                                                      staticClass:
                                                        "row mb-2 danger-pikto"
                                                    },
                                                    [
                                                      _vm._m(5, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto text-center"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                49
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-49-" +
                                                                  item2.id
                                                              },
                                                              _vm._l(
                                                                item2.texts.value.split(
                                                                  ","
                                                                ),
                                                                function(
                                                                  url,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "img",
                                                                    {
                                                                      key:
                                                                        "img-49-" +
                                                                        item2.id +
                                                                        "-" +
                                                                        index,
                                                                      staticClass:
                                                                        "danger-img mr-2 img-fluid d-inline-block",
                                                                      attrs: {
                                                                        src: url
                                                                      }
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 52
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "signal-52-" + item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(6, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                52
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-52-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 55
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "danger-55-" + item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(7, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                55
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-55-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 58
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "safety-58-" + item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(8, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                58
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-58-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 61
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "additional-61-" +
                                                        item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(9, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                61
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-61-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.currentVariation.properties.filter(
                                      function(p) {
                                        return p.propertyId === 56
                                      }
                                    ),
                                    function(prop) {
                                      return _c(
                                        "div",
                                        {
                                          key: "comp-c-" + prop.id,
                                          staticClass: "mt-5"
                                        },
                                        [
                                          _c("h4", [
                                            _vm._v("Hinweise Komponente C")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "danger-hints mt-4"
                                            },
                                            [
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 50
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "danger-pikto-50-" +
                                                        item.id,
                                                      staticClass:
                                                        "row mb-2 danger-pikto"
                                                    },
                                                    [
                                                      _vm._m(10, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto text-center"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                50
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-50-" +
                                                                  item2.id
                                                              },
                                                              _vm._l(
                                                                item2.texts.value.split(
                                                                  ","
                                                                ),
                                                                function(
                                                                  url,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "img",
                                                                    {
                                                                      key:
                                                                        "img-50-" +
                                                                        item2.id +
                                                                        "-" +
                                                                        index,
                                                                      staticClass:
                                                                        "danger-img mr-2 img-fluid d-inline-block",
                                                                      attrs: {
                                                                        src: url
                                                                      }
                                                                    }
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 53
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "signal-53-" + item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(11, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                53
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-53-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 56
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "danger-56-" + item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(12, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                56
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-56-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 59
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "safety-59-" + item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(13, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                59
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-59-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.currentVariation.properties.filter(
                                                  function(p) {
                                                    return p.propertyId === 62
                                                  }
                                                ),
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "additional-62-" +
                                                        item.id,
                                                      staticClass: "row mb-2"
                                                    },
                                                    [
                                                      _vm._m(14, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-10 col-sm-8 mx-auto"
                                                        },
                                                        _vm._l(
                                                          _vm.currentVariation.properties.filter(
                                                            function(p) {
                                                              return (
                                                                p.propertyId ===
                                                                62
                                                              )
                                                            }
                                                          ),
                                                          function(item2) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "span-62-" +
                                                                  item2.id
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item2.texts
                                                                      .value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _vm._m(15, true)
                          ]
                        )
                      }
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "buy-box p-4 bg-gray mb-4" },
                      [
                        _vm.attributes.length || Object.keys(_vm.units).length
                          ? _c("div", {}, [_c("variation-select")], 1)
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentVariation.variation.bundleType === "bundle"
                          ? _c("item-bundle", {
                              attrs: {
                                "bundle-type":
                                  _vm.currentVariation.variation.bundleType,
                                "bundle-components":
                                  _vm.currentVariation.bundleComponents
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("before-price"),
                        _vm._v(" "),
                        _vm.currentVariation.filter.isSalable &&
                        _vm.variationGroupedProperties.length
                          ? _c("div", [_c("order-property-list")], 1)
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentVariation.texts.name3 != "N / A"
                          ? _c("div", { staticClass: "name3" }, [
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(_vm._s(_vm.currentVariation.texts.name3))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("graduated-prices"),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm._m(16),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("item-price", {
                          attrs: {
                            "show-cross-price": _vm.isRecommendedPriceActive
                          }
                        }),
                        _vm._v(" "),
                        _vm._t("after-price"),
                        _vm._v(" "),
                        _c("item-availability"),
                        _vm._v(" "),
                        _c("div", { staticClass: "my-3" }, [
                          _c(
                            "div",
                            { staticClass: "w-100" },
                            [_vm._t("before-add-to-basket")],
                            2
                          ),
                          _vm._v(" "),
                          _vm.currentVariation.item.id == 137 ||
                          _vm.currentVariation.item.id == 139 ||
                          _vm.currentVariation.item.id == 140 ||
                          _vm.currentVariation.item.id == 143
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "alert alert-warning d-block w-100"
                                },
                                [
                                  _vm._v(
                                    "\n                  Dieses Produkt ist nicht an Privatpersonen lieferbar!\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.item.itemType === "set"
                            ? _c(
                                "div",
                                { staticClass: "alert alert-info w-100" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemSetInfo"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "col-12 px-0 my-3 basket-wrapper"
                                },
                                [
                                  _c("add-to-basket", {
                                    attrs: {
                                      "variation-id":
                                        _vm.currentVariation.variation.id,
                                      "is-salable":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-children":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter
                                          .hasActiveChildren,
                                      "interval-quantity":
                                        _vm.currentVariation.variation
                                          .intervalOrderQuantity || 1,
                                      "minimum-quantity":
                                        _vm.currentVariation.variation
                                          .minimumOrderQuantity,
                                      "maximum-quantity":
                                        !!_vm.currentVariation.variation
                                          .maximumOrderQuantity &&
                                        _vm.currentVariation.variation
                                          .maximumOrderQuantity > 0
                                          ? _vm.currentVariation.variation
                                              .maximumOrderQuantity
                                          : null,
                                      "order-properties": _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.property.isOderProperty
                                        }
                                      ),
                                      "has-order-properties":
                                        _vm.currentVariation.hasOrderProperties,
                                      "has-required-order-property":
                                        _vm.currentVariation
                                          .hasRequiredOrderProperty,
                                      "use-large-scale": false,
                                      "show-quantity": true,
                                      "item-url": _vm._f("itemURL")(
                                        _vm.currentVariation
                                      ),
                                      "is-variation-selected":
                                        _vm.isVariationSelected &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-price": _vm._f(
                                        "hasItemDefaultPrice"
                                      )(_vm.currentVariation)
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "w-100" },
                            [_vm._t("after-add-to-basket")],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _vm._t("additional-content-after-add-to-basket"),
                        _vm._v(" "),
                        _vm._t("additional-content-after-vat")
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "icons-wrapper d-flex justify-content-around"
                      },
                      [
                        _c("img", {
                          staticClass: "img-fluid mb-3",
                          attrs: {
                            src: _vm.$translate(
                              "easygroundVueTheme::SingleItemTheme.Icon1Image"
                            ),
                            alt: _vm.$translate(
                              "easygroundVueTheme::SingleItemTheme.Icon1Text"
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "img-fluid mb-3",
                          attrs: {
                            src: _vm.$translate(
                              "easygroundVueTheme::SingleItemTheme.Icon2Image"
                            ),
                            alt: _vm.$translate(
                              "easygroundVueTheme::SingleItemTheme.Icon2Text"
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "img-fluid mb-3",
                          attrs: {
                            src: _vm.$translate(
                              "easygroundVueTheme::SingleItemTheme.Icon3Image"
                            ),
                            alt: _vm.$translate(
                              "easygroundVueTheme::SingleItemTheme.Icon3Text"
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "img-fluid mb-3",
                          attrs: {
                            src: _vm.$translate(
                              "easygroundVueTheme::SingleItemTheme.Icon4Image"
                            ),
                            alt: _vm.$translate(
                              "easygroundVueTheme::SingleItemTheme.Icon4Text"
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "img-fluid mb-3",
                          attrs: {
                            src: _vm.$translate(
                              "easygroundVueTheme::SingleItemTheme.Icon5Image"
                            ),
                            alt: _vm.$translate(
                              "easygroundVueTheme::SingleItemTheme.Icon5Text"
                            )
                          }
                        })
                      ]
                    )
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-6" }, [
                _vm.downloadProperties.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "mt-0 mt-md-3 download-wrapper p-4 bg-gray build"
                      },
                      [
                        _vm._m(17),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "downloads" },
                          _vm._l(_vm.downloadProperties, function(prop, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "download mb-2 mr-2 d-inline-block"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-dark text-white border-radius px-4",
                                    attrs: {
                                      href: prop.texts.value,
                                      title: prop.property.names.name,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(prop.property.names.name))
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mt-5 mt-md-3 description" }, [
                  _c("span", { staticClass: "font-weight-bold mb-4" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Ceres::Template.singleItemDescription")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "mb-4",
                    domProps: {
                      innerHTML: _vm._s(_vm.currentVariation.texts.description)
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-6" }, [
                _c(
                  "div",
                  { staticClass: "fs-xselling mb-4 mt-0 mt-md-3" },
                  [_vm._t("cross-selling-accessory")],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "eu-respo mb-4 mt-0 mt-md-3" }, [
                  _vm.currentVariation.item.manufacturer.responsibleName != null
                    ? _c("p", { staticClass: "font-weight-bold mb-1" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.singleItemEuResponsiblePerson"
                            )
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleName
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleStreet
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleHouseNo
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsiblePostCode
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleTown
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.currentVariation.item.manufacturer
                        .responsibleCountryObject
                        ? _c("span", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.currentVariation.item.manufacturer
                                    .responsibleCountryObject.name
                                ) +
                                "\n                "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleEmail
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsiblePhoneNo
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleContactUrl
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.currentVariation.item.manufacturer.name != null
                      ? _c("p", { staticClass: "font-weight-bold mb-1" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.singleItemManufacturer"
                              )
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.name)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.legalName
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.street)
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.houseNo)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.postcode
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.town)
                        )
                      ]),
                      _vm._v(" "),
                      _vm.currentVariation.item.manufacturer.countryObject
                        ? _c("span", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.currentVariation.item.manufacturer
                                    .countryObject.name
                                ) +
                                "\n                "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.email)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.url)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.phoneNumber
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.faxNumber
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.contactUrl
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "single page-content" }, [
            _vm.currentVariation.item.id == 138 ||
            _vm.currentVariation.item.id == 137 ||
            _vm.currentVariation.item.id == 190 ||
            _vm.currentVariation.item.id == 202 ||
            _vm.currentVariation.item.id == 2824
              ? _c("div", { staticClass: "container-fluid bg-gray py-5" }, [
                  _c("div", { staticClass: "container-max" }, [
                    _c("div", { staticClass: "row video" }, [
                      _c("div", { staticClass: "col-12 col-md-6" }, [
                        _c(
                          "div",
                          [
                            _vm._l(
                              _vm.currentVariation.variationProperties,
                              function(variationPropertyGroup) {
                                return [
                                  _vm._l(
                                    variationPropertyGroup.properties,
                                    function(variationProperty) {
                                      return [
                                        variationProperty.id == 12
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  key:
                                                    "video-" +
                                                    variationPropertyGroup.id +
                                                    "-" +
                                                    variationProperty.id,
                                                  staticClass: "video-container"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "youtubevideo",
                                                      attrs: {
                                                        "data-embed":
                                                          variationProperty
                                                            .values.value
                                                      }
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "play-button"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ]
                                    }
                                  )
                                ]
                              }
                            )
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-6 mt-3 mt-md-0 d-flex flex-wrap align-items-center"
                        },
                        [
                          _c("div", [
                            _c("p", { staticClass: "h5 single_headline" }, [
                              _vm._v("Produktvideo")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "h3 single_headline" }, [
                              _vm._v(
                                _vm._s(_vm._f("itemName")(_vm.currentVariation))
                              )
                            ]),
                            _vm._v(" "),
                            _vm._m(18)
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              : _c("div", { staticClass: "container-fluid bg-gray py-5" }, [
                  _vm._m(19)
                ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container-max feed-item" },
              [
                _vm._t("item-list-container"),
                _vm._v(" "),
                _c("feedback-container", {
                  staticClass: "widget-inner",
                  attrs: {
                    options: {
                      allowFeedbacksOnlyIfPurchased: false,
                      allowNoRatingFeedback: false,
                      feedbacksPerPage: 10,
                      numberOfFeedbacks: 1,
                      timestampVisibility: true,
                      allowGuestFeedbacks: true
                    },
                    classes: "",
                    styles: "",
                    id: "feedback-container"
                  }
                }),
                _vm._v(" "),
                _vm._m(20)
              ],
              2
            )
          ])
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Gefahrenpiktogramm")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Signalwort")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Gefahrenhinweise")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Sicherheitshinweise")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Zusätzliche Angaben")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Gefahrenpiktogramm")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Signalwort")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Gefahrenhinweise")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Sicherheitshinweise")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Zusätzliche Angaben")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Gefahrenpiktogramm")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Signalwort")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Gefahrenhinweise")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Sicherheitshinweise")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-4 mb-2 mb-sm-0" }, [
      _c("strong", [_vm._v("Zusätzliche Angaben")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "descriptionToggle" } }, [
      _c(
        "button",
        {
          staticClass:
            "btn btn-link btn-inline-block text-dark text-decoration-none py-2 pl-0"
        },
        [
          _c("span", { staticClass: "show-more" }, [
            _vm._v("mehr anzeigen "),
            _c("i", {
              staticClass: "fa fa-chevron-down float-none text-dark small"
            })
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "show-less" }, [
            _vm._v("weniger anzeigen "),
            _c("i", {
              staticClass: "fa fa-chevron-down float-none text-dark small"
            })
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      {
        staticClass:
          "static-usps list-unstyled d-flex flex-wrap justify-content-between"
      },
      [
        _c(
          "li",
          {
            staticClass:
              "d-flex align-items-center small font-weight-bold mb-3 mb-xl-0"
          },
          [
            _c("i", {
              staticClass: "fa fa-check-circle-o mr-2",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "d-flex" }, [
                _vm._v("kostenlose Hotline")
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "text-dark",
                  attrs: { href: "tel:+4956122071080" }
                },
                [_vm._v(" +49 (0)561 220 710 80")]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "d-flex align-items-center small font-weight-bold mb-3 mb-xl-0"
          },
          [
            _c("i", {
              staticClass: "fa fa-check-circle-o mr-2",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "d-flex" }, [
                _vm._v("kostenloser Versand")
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("innerhalb Deutschlands")])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "d-flex align-items-center small font-weight-bold mb-0 mb-xl-0"
          },
          [
            _c("i", {
              staticClass: "fa fa-check-circle-o mr-2",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "d-flex" }, [_vm._v("Guter Service")]),
              _vm._v(" "),
              _c("span", [_vm._v("Gute Qualität")])
            ])
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h4", { staticClass: "mb-3 mt-0" }, [_vm._v("Downloads")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Wir zeigen dir wie unser Produkt ganz einfach verwenden kannst. Noch weitere hilfreiche Verarbeitungsvideos findest du "
      ),
      _c("a", { attrs: { href: "/verarbeitungsvideos" } }, [_vm._v("hier")]),
      _vm._v("!")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-max" }, [
      _c("div", { staticClass: "row video" }, [
        _c("div", { staticClass: "col-12 col-md-6" }, [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "youtubevideo",
                attrs: { "data-embed": "e32UAZoIeaM" }
              },
              [
                _c("div", { staticClass: "play-button" }),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src:
                      "https://img.youtube.com/vi/e32UAZoIeaM/maxresdefault.jpg"
                  }
                })
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-12 col-md-6 mt-3 mt-md-0 d-flex flex-wrap align-items-center"
          },
          [
            _c("div", [
              _c("p", { staticClass: "h5 single_headline" }, [
                _vm._v("Produktvideo")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "h3 single_headline" }, [
                _vm._v("Easy zum neuen Garagenboden")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Noch weitere hilfreiche Verarbeitungsvideos findest du "
                ),
                _c("a", { attrs: { href: "/verarbeitungsvideos" } }, [
                  _vm._v("hier")
                ]),
                _vm._v("!")
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-box px-3 py-5" }, [
      _c("div", { staticClass: "row mb-4" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-10 col-lg-8 mx-md-auto text-center" },
          [
            _c("p", { staticClass: "m-0 h1" }, [_vm._v("FRAGEN & ANTWORTEN")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                Wir freuen uns, dass Sie sich für unseren flüssigen Bodenbelag und das Zubehör interessieren. In unserem "
              ),
              _c("a", { attrs: { href: "/faq" } }, [_vm._v("FAQ")]),
              _vm._v(
                " haben wir zahlreiche Fragen zur Produktpalette und zur\n                Verwendung unserer Produkte zusammengetragen.\n              "
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row font-heading px-3" }, [
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c("ul", { staticClass: "list-unstyled mb-0" }, [
            _c("li", { staticClass: "mb-2" }, [
              _vm._v("Wo kann ich EASYGROUND anwenden?")
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "mb-2" }, [
              _vm._v("Wie viel EASYGROUND benötige ich?")
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "mb-2" }, [
              _vm._v("Muss ich den Boden vorbehandeln?")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c("ul", { staticClass: "list-unstyled mb-0" }, [
            _c("li", { staticClass: "mb-2" }, [
              _vm._v("Worauf hält EASYGROUND?")
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "mb-2" }, [
              _vm._v("Was muss ich bei der Verarbeitung beachten?")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c("ul", { staticClass: "list-unstyled mb-0" }, [
            _c("li", { staticClass: "mb-2" }, [
              _vm._v("Kann ich EASYGROUND im Baumarkt kaufen?")
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "mb-2" }, [
              _vm._v("Welche Gestaltungsmöglichkeiten gibt es mit EASYGROUND?")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 text-center mt-4" }, [
          _c("a", { staticClass: "btn btn-red", attrs: { href: "/faq" } }, [
            _vm._v("Zu den Fragen")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }